import { render } from "./ArrivalHeader.vue?vue&type=template&id=09168539"
import script from "./ArrivalHeader.vue?vue&type=script&lang=ts"
export * from "./ArrivalHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
